import { types } from "mobx-state-tree";
export var BaseModel = types.model('BaseModel', {
    _id: types.maybeNull(types.optional(types.string, '')),
});
